module.exports = __webpack_public_path__ + "static/babel-722ecea72ec11bec6c647efcd94aab09.png";